export var check_font_load = (font_family) => {
    var font_iterator = document.fonts.entries()
    var entries = font_iterator.next();
    while(entries && entries.value){
        for(var i in entries.value){
            if(entries.value[i].family == font_family){
                return true;
            }
        }
        entries = font_iterator.next();
    }

    return false;
}

export var add_fonts = (fonts) => {
    console.log("adding fonts....");
    for (let i = 0; i < fonts.length; i++) {
        if (check_font_load(fonts[i].name)) continue;
        var font = new window.FontFace(fonts[i].name, 'url('+global.config.server_path+fonts[i].src+')');
        window.document.fonts.add(font);
        font.load().catch(err => console.log(err));
    }
}